import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AutoSizer } from 'react-virtualized/dist/es/AutoSizer';
import { List } from 'react-virtualized/dist/es/List';
import * as cx from 'classnames';
import { searchArea } from 'actions/regions/areas';
import IconButton from 'material-ui/IconButton/IconButton';
import SearchIcon from 'material-ui/svg-icons/action/search';
import Search from './Search';
import Filter from './Filter';

const FilterAreas = (props) => {
    const [areaName, setAreaName] = useState('');
    const [filter, setFilter] = useState('all');
    const [filteredAreas, setFilteredAreas] = useState([]);
    const listRef = useRef(null);

    const checkSelect = (item) => {
        const updatedAreas = filteredAreas.map(area => ({
            ...area,
            isActive: item._id === area._id,
        }));

        setFilteredAreas(updatedAreas);
        props.onSelectArea(_.cloneDeep(item));
    };

    const filterAreas = (areas) => {
        const filtered = areas.filter((area) => {
            if (area.name.toLowerCase().includes(areaName.toLowerCase())) {
                return true;
            }

            if (!area.fields) {
                return false;
            }

            return area.fields.some(field => 
                field.name.toLowerCase().includes(areaName.toLowerCase()));
        });

        switch (filter) {
        case 'noPorts':
            return filtered
                .filter(a => !a.mainRegion)
                .filter(area => area.childs.length === 0);
        case 'noMainPorts':
            return filtered
                .filter(a => !a.mainRegion)
                .filter(area => !(area.mainPorts && area.mainPorts.length > 0));
        case 'mainRegions':
            return filtered.filter(area => area.mainRegion);
        default:
            return filtered.filter(a => !a.mainRegion);
        }
    };

    const changeSearch = (value) => {
        setAreaName(value);
    };

    const changeFilter = (value) => {
        setFilter(value);
    };

    useEffect(() => {
        setFilteredAreas(filterAreas(props.areas.items));
    }, [filter, areaName]);

    useEffect(() => {
        setFilteredAreas(filterAreas(props.areas.items));
    }, [props.areas.items]);

    useEffect(() => {
        if (props.selectedArea) {
            const areaIndex = filteredAreas.findIndex(area => area._id === props.selectedArea);
            if (listRef.current) {
                listRef.current.scrollToRow(areaIndex);
            }
        }
    }, [props.selectedArea, filteredAreas]);

    const renderRow = ({ index, key, style }) => {
        const area = filteredAreas[index];
        const selected = props.selectedArea === area._id;
        const parentCount = (area.parents || [])
            .map(id => props.areas.items.find(a => a._id === id))
            .reduce((count, area) => (area ? count + 1 : count), 0);

        return (
            <div
                role='button'
                tabIndex={0}
                style={{
                    ...style, display: 'flex', justifyContent: 'space-between', fontWeight: area.mainRegion ? 'bold' : 'normal', 
                }}
                key={key}
                className={cx('list-item', { active: selected })}
                onClick={() => { checkSelect(area); }}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        checkSelect(area);
                    }
                }}
            >
                <div style={{ lineHeight: '16px', paddingTop: '8px' }}>
                    {area.name}
                    <div style={{ fontSize: 'smaller' }}>
                        <b style={{ color: parentCount > 1 ? 'rgb(255, 64, 129)' : '' }}>
                            {parentCount}
                        </b>
                        {parentCount === 1 ? ' parent ' : ' parents '}
                        <b>{area.childAreaCount}</b>
                        {area.childAreaCount === 1 ? ' child ' : ' children '}
                        <b>{area.childPortCount}</b>
                        {area.childPortCount === 1 ? ' port' : ' ports'}
                    </div>
                </div>
                <IconButton onClick={() => {
                    props.searchArea(area.name);
                    props.router.push('/regions/altareas');
                }}
                >
                    <SearchIcon />
                </IconButton>
            </div>
        );
    };

    return (
        <div className='area-panel'>
            <Search changeSearch={changeSearch} />
            <Filter changeFilter={changeFilter} />

            <div className='paper-block margin-10 area-list'>
                <span className='name-block absolute small-name'>Areas to select</span>

                <div className='list'>
                    <AutoSizer>
                        {
                            ({ width, height }) => (<List
                                ref={listRef}
                                _updateOnly={props.areas}
                                selectedArea={props.selectedArea} // only to cause update
                                rowRenderer={renderRow}
                                height={height}
                                width={width}
                                rowHeight={48}
                                rowCount={filteredAreas.length}
                            />)
                        }
                    </AutoSizer>
                </div>
            </div>
        </div>
    );
};

export default connect(
    (state, {
        selectedArea, areas, onSelectArea, router, 
    }) => ({
        selectedArea,
        areas,
        onSelectArea,
        router,
    }),
    dispatch => bindActionCreators(
        {
            searchArea,
        },
        dispatch,
    ),
)(FilterAreas);



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/FilterAreas/Component.jsx